import { PassLogoutProvider } from '../auth/passLogoutRef';
import { resolveUiLocale } from './appUiLocale';

export function buildExportQueryStringFromParams(params = {}, opts = {}) {
  const { includePrintColumns = false, printLayout, printOrientation, printColumns } = opts;
  const extra = { ...(params || {}) };
  delete extra.page;
  delete extra.size;
  try {
    const loc = resolveUiLocale(PassLogoutProvider.user);
    if (loc && ['sk', 'en', 'de'].includes(loc)) {
      extra.locale = loc;
    }
  } catch (_) {
    /* ignore */
  }
  if (includePrintColumns) {
    if (Array.isArray(printColumns) && printColumns.length > 0) {
      extra.print_columns = JSON.stringify(printColumns);
    }
    extra.print_layout = printLayout === 'minimal' ? 'minimal' : 'branded';
    extra.print_engine = 'professional';
    if (printOrientation === 'portrait' || printOrientation === 'landscape') {
      extra.orientation = printOrientation;
    }
  }
  const qs = new URLSearchParams();
  Object.keys(extra).forEach((k) => {
    if (extra[k] !== undefined && extra[k] !== null && String(extra[k]).trim() !== '') qs.set(k, String(extra[k]));
  });
  const q = qs.toString();
  return q ? `?${q}` : '';
}

export function openPrintHtmlWindow(html) {
  const w = window.open('', '_blank');
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  try { w.focus(); } catch (_) {}
  return true;
}

export function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
